<template>
    <div class="box">
        <div class="box-info" style="margin: 0 0 20px 0;">
            <el-form  label-width="120px">
                <el-form-item label="产品ID：" v-if="productLibraryInfo.id">
                    <el-input v-model="productLibraryInfo.id" size="small" disabled></el-input>
                </el-form-item>
                <el-form-item label="是否为主险">
                    <el-select v-model="productLibraryInfo.main" placeholder="请选择" size="small">
                        <el-option
                            v-for="item in payMonthlyOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span class="label-text">请选择产品是否是主险</span>
                </el-form-item>
                <el-form-item label="是否已发布">
                    <el-select v-model="productLibraryInfo.published" placeholder="请选择" size="small">
                        <el-option
                            v-for="item in payMonthlyOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <span class="label-text">请选择产品是否发布</span>
                </el-form-item>
                <el-form-item label="产品类型：">
                    <el-select v-model="productLibraryInfo.type" placeholder="请选择" size="small">
                        <el-option
                            v-for="item in typeOptions"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                        </el-option>
                    </el-select>
                    <span class="label-text">请选择产品类型</span>
                </el-form-item>
            </el-form>
            
        </div>

        <div class="box-info">
            <div class="title">基础信息</div>
            <el-form ref="form" :model="productLibraryInfo" label-width="120px">
                <el-form-item label="产品名称：" prop="amount">
                    <el-input v-model="productLibraryInfo.basicInfo.name" size="small" label-width="180px"></el-input>
                    <span class="label-text">请填写产品在渠道的名称</span>
                </el-form-item>
                <el-form-item label="产品合同名：">
                    <el-input v-model="productLibraryInfo.basicInfo.contractName" size="small" />
                    <span class="label-text">请填写产品的合同名称</span>
                </el-form-item>
                <el-form-item label="产品别名：">
                    <div style="display: inline-block; min-width: 400px;">
                        <div v-for="(item, index) in alias" :key="index">
                            <el-button type="danger"
                                       icon="el-icon-delete"
                                       size="mini"
                                       v-if="index !== 0"
                                       @click="removeRows('alias',index)"
                                       circle
                                       style="margin: 0 10px 0 0;"
                            ></el-button>
                            <el-input v-model="item.value" size="small"  />
                        </div>
                        <el-button type="primary"
                                   icon="el-icon-circle-plus-outline"
                                   size="mini"
                                   @click="addRows('alias')"
                                   plain>添加别名</el-button>
                    </div>
                    
                    <span class="label-text">请填写用户搜索产品时起作用的产品别名的关键词(注：nlp等相关地方使用的是老产品产品别名)</span>
                </el-form-item>
                <el-form-item label="产品卖点：">
                    <el-input v-model="productLibraryInfo.basicInfo.sellingPoints" size="small" />
                    <span class="label-text">请填写产品卖点</span>
                </el-form-item>
                <el-form-item label="产品描述：">
                    <div style="display: inline-block; min-width: 400px;">
                        <div v-for="(item, index) in description" :key="index">
                            <el-button type="danger"
                                       icon="el-icon-delete"
                                       size="mini"
                                       v-if="index !== 0"
                                       @click="removeRows('description',index)"
                                       circle
                                       style="margin: 0 10px 0 0;"
                            ></el-button>
                            <el-input v-model="item.value" size="small"  />
                        </div>
                        <el-button type="primary"
                                   icon="el-icon-circle-plus-outline"
                                   size="mini"
                                   @click="addRows('description')"
                                   plain>添加描述</el-button>
                    </div>
                    <span class="label-text">请填写产品描述信息(注：每条描述信息单独添加，如1.好 2.很好 则添加两条描述信息)</span>
                </el-form-item>
                <el-form-item label="公司名称：">
                    <el-select v-model="productLibraryInfo.basicInfo.companyId" placeholder="请选择" size="small">
                        <el-option
                            v-for="item in companyOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <span class="label-text" style="margin: 0 0 0 255px;">请选择保险公司</span>
                </el-form-item>
                <el-form-item label="产品标签：">
                    <div style="display: inline-block; min-width: 400px;">
                        <div v-for="(item, index) in tags" :key="index">
                            <el-button type="danger"
                                       icon="el-icon-delete"
                                       size="mini"
                                       v-if="index !== 0"
                                       @click="removeRows('tags',index)"
                                       circle
                                       style="margin: 0 10px 0 0;"
                            ></el-button>
                            <el-input v-model="item.value" size="small"  />
                        </div>
                        <el-button type="primary"
                                   icon="el-icon-circle-plus-outline"
                                   size="mini"
                                   @click="addRows('tags')"
                                   plain>添加标签</el-button>
                    </div>
                    <span class="label-text">请填写产品标签(注：每条标签单独添加 如智能核保 人工核保 则添加两条产品标签)</span>
                </el-form-item>
                <el-form-item label="等待期(天)：">
                    <el-input v-model="productLibraryInfo.basicInfo.waitingPeriod" size="small" />
                    <span class="label-text">请填写投保后的等待期，如：90</span>
                </el-form-item>
                <el-form-item label="犹豫期(天)：">
                    <el-input v-model="productLibraryInfo.basicInfo.coolingOffPeriod" size="small" />
                    <span class="label-text">请填写投保后的犹豫期，如：20</span>
                </el-form-item>

            </el-form>
        </div>

        <div class="box-info">
            <div class="title">投保要求</div>
            <el-select v-model="productLibraryInfo.requirement.role" placeholder="请选择" class="box-margin" size="small">
                <el-option
                    v-for="item in requirementOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>
            <span class="label-text" style="margin: 0 0 0 350px;">请选择保险角色</span>
            <div class="box-margin">
                <div style="font-size: 14px;">年龄要求:<span class="label-text" style="margin: 0 0 0 480px;">请填写投保年龄范围(注：最小投保年龄/最大投保年龄，如最小投保年龄1年2个月28天--->天：28 月：2 年：1)</span></div>
                <div class="box-margin" style="font-size: 12px;">最小值</div>
                <el-form style="width: 100%;margin: 0 0 0 40px;" inline>
                    <el-form-item label="天：" label-width="50px">
                        <el-input v-model="conditionAgeMin.day" size="small" style="width: 100px;" />
                    </el-form-item>
                    <el-form-item label="月：" label-width="50px">
                        <el-input v-model="conditionAgeMin.month" size="small" style="width: 100px;" />
                    </el-form-item>
                    <el-form-item label="岁：" label-width="50px">
                        <el-input v-model="conditionAgeMin.year" size="small" style="width: 100px;" />
                    </el-form-item>
                </el-form>
                <div class="box-margin" style="font-size: 12px;"><span>最大值</span></div>
                <el-form style="width: 100%;margin: 0 0 0 40px;" inline>
                    <el-form-item label="天：" label-width="50px">
                        <el-input v-model="conditionAgeMax.day" size="small" style="width: 100px;" />
                    </el-form-item>
                    <el-form-item label="月：" label-width="50px">
                        <el-input v-model="conditionAgeMax.month" size="small" style="width: 100px;" />
                    </el-form-item>
                    <el-form-item label="岁：" label-width="50px">
                        <el-input v-model="conditionAgeMax.year" size="small" style="width: 100px;" />
                    </el-form-item>
                </el-form>
            </div>
            <div class="box-margin pay-method-box">
                <span>职业要求:</span>
                <el-select v-model="productLibraryInfo.requirement.conditionSet.conditions[1].params.occupations" multiple placeholder="请选择" size="small">
                    <el-option
                        v-for="item in conditionOccupationOptions"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                </el-select>
                <span class="label-text" style="margin: 0 0 0 280px;">请选择投保职业要求</span>
            </div>
        </div>

        <div class="box-info">
            <div class="title">保障期限<span class="label-text" style="margin: 0 0 0 520px;">请选择保障期限(注：如果下拉框中无符合要求的项，可以手工填写)</span></div>
            <el-select
                style="margin: 0 0 0 50px;"
                v-model="baozhangqixianAge"
                multiple
                filterable
                allow-create
                default-first-option
                size="small"
                placeholder="至XX岁">
                <el-option
                    v-for="item in ageOptions"
                    :key="item"
                    :label="`${item}岁`"
                    :value="item">
                </el-option>
            </el-select>
            <el-select
                style="margin: 0 0 0 20px;"
                v-model="baozhangqixian"
                multiple
                filterable
                allow-create
                default-first-option
                size="small"
                placeholder="保XX年">
                <el-option
                    v-for="item in yearOptions"
                    :key="item"
                    :label="`${item}年`"
                    :value="item">
                </el-option>
            </el-select>

            <el-checkbox v-model="lifelongType" class="box-margin">终身</el-checkbox>

        </div>
        
        <div class="box-info">
            <div class="title">保额<span class="label-text" style="margin: 0 0 0 550px;">请填写可投保额度(注：区间步进/非区间两种方式)</span></div>
            <div class="box-margin">
                <el-radio v-model="amountType" label="1">区间</el-radio>
                <el-radio v-model="amountType" label="2">非区间</el-radio>
                <el-form class="box-margin" v-if="amountType === '1'">
                    <el-form-item label="区间最小值(万元)：">
                        <el-input size="small" v-model="amountRange.options[0]"></el-input>
                        <span class="label-text">最小保额</span>
                    </el-form-item>
                    <el-form-item label="区间最大值(万元)：">
                        <el-input size="small" v-model="amountRange.options[1]"></el-input>
                        <span class="label-text">最大保额</span>
                    </el-form-item>
                    <el-form-item label="按多少递增(元)：">
                        <el-input size="small" v-model="amountRange.step"></el-input>
                        <span class="label-text" style="margin: 0 0 0 65px;">最小保额到最大保额之间可以递进的最小单位</span>
                    </el-form-item>
                </el-form>
                <div v-if="amountType === '2'">
                    <el-select
                        style="margin: 30px 0 0 20px;"
                        v-model="baoe"
                        multiple
                        filterable
                        allow-create
                        default-first-option
                        size="small"
                        placeholder="请选择保额">
                        <el-option
                            v-for="item in bxamountOptions"
                            :key="item.key"
                            :label="`${item.value}万元`"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </div>
                
            </div>
        </div>

        <div class="box-info">
            <div class="title">交费方式<span class="label-text" style="margin: 0 0 0 580px;">请选择交费方式</span></div>
            <div>
                <el-checkbox v-model="payMethodOptions[0].checked" class="box-margin">趸交</el-checkbox>
                <span class="label-text" style="margin: 0 0 0 562px;">1年期交费且不支持月缴</span>
            </div>
            <div>
                <el-checkbox v-model="payMethodOptions[1].checked" class="box-margin">年交</el-checkbox>
                <el-form style="margin: 0 0 0 50px;" v-if="payMethodOptions[1].checked" inline>
                    <div>交XX年</div>
                    <el-form-item v-for="(v, i) in payMethod" :key="i">
                        <el-button type="danger"
                                   icon="el-icon-delete"
                                   size="mini"
                                   v-if="i !== 0"
                                   @click="removeRows('payMethod',i)"
                                   circle
                                   style="margin: 0 10px 0 0;"
                        ></el-button>
                        <el-input v-model="v.value" style="width: 100px;" size="small"></el-input>
                        <el-select v-model="v.payMonthly" placeholder="是否支持月缴" size="small" style="width: 140px;">
                            <el-option
                                v-for="item in payMonthlyOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary"
                               icon="el-icon-circle-plus-outline"
                               size="mini"
                               @click="addRows('payMethod')"
                               style="margin: 5px 0 0;"
                               plain>添加缴费年限</el-button>
                </el-form>
                <el-form style="margin: 0 0 0 50px;" v-if="payMethodOptions[1].checked" inline>
                    <div>至XX岁</div>
                    <el-form-item v-for="(v, i) in payMethodAge" :key="i">
                        <el-button type="danger"
                                   icon="el-icon-delete"
                                   size="mini"
                                   v-if="i !== 0"
                                   @click="removeRows('payMethodAge',i)"
                                   circle
                                   style="margin: 0 10px 0 0;"
                        ></el-button>
                        <el-input v-model="v.value" style="width: 100px;" size="small"></el-input>
                        <el-select v-model="v.payMonthly" placeholder="是否支持月缴" size="small" style="width: 140px;">
                            <el-option
                                v-for="item in payMonthlyOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary"
                               icon="el-icon-circle-plus-outline"
                               size="mini"
                               @click="addRows('payMethodAge')"
                               style="margin: 5px 0 0;"
                               plain>添加缴费</el-button>
                </el-form>

            </div>
            
        </div>
        
        
        <el-button type="primary" @click="dialogVisible = true">保存</el-button>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>确认添加/修改此产品吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible  = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
    
</template>
<script>
import request from "@/api/request.js";
export default {
    props: ['productLibraryInfo'],
    data(){
        return {
            currentFiles: [],
            dialogVisible: false,
            conditionAgeMin: {
                day: '',
                month: '',
                year: '',
            },
            conditionAgeMax: {
                day: '',
                month: '',
                year: '',
            },
            options: [{
                label: '趸交',
                value: 'payInFull'
            },{
                label: '年交',
                value: 'payAnnually'
            }],
            payAnnuallyOptions: [10,15,20,30],
            payMonthlyOptions: [{label: '是',value: true},{label: '否',value: false}],
            //age: true是年龄，false是时间段
            validPeriodAge: [{
                value: ''
            }],
            validPeriodYear: [{
                value: ''
            }],
            ageType: false,
            periodType: false,
            lifelongType: false,
            baseInfo: {},
            alias: [],
            description: [],
            tags: [],
            conditionOccupationOptions: [{"code":1,"name":"1类职业"},{"code":2,"name":"2类职业"},{"code":3,"name":"3类职业"},{"code":4,"name":"4类职业"},{"code":5,"name":"5类职业"},{"code":6,"name":"6类职业"}],
            payMethodOptions:[
                { type: "payInFull", checked: false},
                { type: "payAnnually", checked: false},
            ],
            payMethod: [{
                value: ''
            }],
            payMethodAge: [{
                value: ''
            }],
            companyOptions: [],
            requirementOptions: [],
            typeOptions: '1',
            amountType: '',
            amountRange: {
                range: true,
                options: ['', ''],
                step: ''
            },
            amountOptions: [],
            bxamountOptions: [],//保额
            baoe: [],
            baozhangqixianAge: [],//至多少岁
            baozhangqixian: [], //保多少年
            ageOptions: [0,17,18,30,31,35,36,40,41,45,46,50,51,55,56,60,61,65,66,70,71,80,81,90,91],
            yearOptions: [1,5,10,15,20,25,30],
        }
    },
    mounted() {
        this.initData()
        this.getProduct()
        this.dealData()
        //this.requirement = this.baseInfo.requirement.classProperties
        //this.requirement_conditionSet = this.requirement.conditionSet.classProperties
        //this.requirement_conditionSet_
        //console.log(this.baseInfo.requirement.classProperties.conditionSet.classProperties.conditions.valueType.classOptions[1].classProperties.occupations.options)
    },
    methods: {
        initData(){
            for(let i = 1; i< 101; i++) {
                this.bxamountOptions.push({
                    value: i * 10,
                    key: `${i * 10}万元`
                })
            }
        },
        dealData(){
            //数据预处理
            this.productLibraryInfo.basicInfo.alias.forEach(item => {
                this.alias.push({value: item})
            })
            this.productLibraryInfo.basicInfo.description.forEach(item => {
                this.description.push({value: item})
            })
            this.productLibraryInfo.basicInfo.tags.forEach(item => {
                this.tags.push({value: item})
            })

            //投保要求，年龄最大值最小值
            this.conditionAgeMin = this.productLibraryInfo.requirement.conditionSet.conditions[0].params.min
            delete this.conditionAgeMin['age']
            this.conditionAgeMax = this.productLibraryInfo.requirement.conditionSet.conditions[0].params.max
            delete this.conditionAgeMax['age']
            
            //交费方式
            let payMethodOptions = this.productLibraryInfo.payMethodOptions
            this.payMethod = []
            this.payMethodAge = []
            payMethodOptions.forEach(item => {
                if(item.type === 'payInFull') {
                    this.payMethodOptions[0].checked = true
                } else {
                    this.payMethodOptions[1].checked = true
                    if(item.params.age) {
                        this.payMethodAge.push({
                            age: true,
                            value: item.params.year,
                            payMonthly: item.params.payMonthly
                        })
                    } else {
                        this.payMethod.push({
                            age: false,
                            value: item.params.year,
                            payMonthly: item.params.payMonthly
                        })
                    }
                    
                    //this.payMethodAge
                }
            })
            
            //保障期限
            let validPeriodOptions = this.productLibraryInfo.validPeriodOptions
            this.validPeriodYear = []
            this.validPeriodAge = []
            validPeriodOptions.forEach(item => {
                if(item.age && item.year === 999) {
                    this.lifelongType = true
                } else if (item.age) {
                    this.baozhangqixianAge.push(item.year)
                } else {
                    item.year > 0 && this.baozhangqixian.push(item.year)
                }
            })
            
            //保额
            if (this.productLibraryInfo.amount.range) {
                this.productLibraryInfo.amount.options[0] = this.productLibraryInfo.amount.options[0]/1E6
                this.productLibraryInfo.amount.options[1] = this.productLibraryInfo.amount.options[1]/1E6
                this.productLibraryInfo.amount.step = this.productLibraryInfo.amount.step/100
                this.amountRange = this.productLibraryInfo.amount
                this.amountType = '1'
            } else {
                Object.keys(this.productLibraryInfo.amount.options).forEach(key => {
                    this.productLibraryInfo.amount.options[key] = this.productLibraryInfo.amount.options[key] / 1E6
                    // this.amountOptions.push({value: this.productLibraryInfo.amount.options[key]})
                    this.baoe.push(`${this.productLibraryInfo.amount.options[key]}万元`)
                })
                this.amountType = '2'
            } 
        },
        getProduct(){
            request.library
                .post(
                    'to_type',
                    {}
                )
                .then(r => {
                    this.baseInfo = r.data
                    this.requirementOptions = this.baseInfo.requirement.classProperties.role.options
                    this.typeOptions = this.baseInfo.type.options
                });
            request.product
                .post(
                    'company_list',
                    {
                        range: [0,1000]
                    }
                )
                .then(res => {
                    this.companyOptions = res.data.list
                })
        },
        save(){
            let alias = []
            let description = []
            let tags = []
            let validPeriodOptions = []
            let payMethodOptions = []
            
            this.lifelongType && validPeriodOptions.push({
                age: true,
                year: 999
            })
            
            this.baozhangqixian.forEach(item => {
                validPeriodOptions.push({
                    age: false,
                    year: parseInt(item)
                })
            })
            this.baozhangqixianAge.forEach(item => {
                validPeriodOptions.push({
                    age: true,
                    year: parseInt(item)
                })
            })

            Object.keys(this.alias).forEach((key) => {
                alias.push(this.alias[key].value)
            })
            Object.keys(this.description).forEach((key) => {
                description.push(this.description[key].value)
            })
            Object.keys(this.tags).forEach((key) => {
                tags.push(this.tags[key].value)
            })

            Object.keys(this.conditionAgeMin).forEach((key) => {
                this.conditionAgeMin[key] = parseInt(this.conditionAgeMin[key]) || 0
            })
            Object.keys(this.conditionAgeMax).forEach((key) => {
                this.conditionAgeMax[key] = parseInt(this.conditionAgeMax[key]) || 0
            })


            this.payMethodOptions[0].checked && delete this.payMethodOptions[0]['checked'] && payMethodOptions.push(this.payMethodOptions[0])
            if(this.payMethodOptions[1].checked){
                this.payMethod.forEach(item => {
                    payMethodOptions.push({
                        type: 'payAnnually',
                        params: {
                            age: false,
                            year: parseInt(item.value) || 0,
                            payMonthly: item.payMonthly
                        }
                    })
                })
                this.payMethodAge.forEach(item => {
                    payMethodOptions.push({
                        type: 'payAnnually',
                        params: {
                            age: true,
                            year: parseInt(item.value) || 0,
                            payMonthly: item.payMonthly
                        }
                    })
                })
            }
            
            let amountOptions = []
            if(this.amountType === '1') {
                //区间
                Object.keys(this.amountRange.options).forEach(key => {
                    this.amountRange.options[key] = parseInt(this.amountRange.options[key]) * 1E6
                })
                this.amountRange.step = parseInt(this.amountRange.step) * 100
                this.productLibraryInfo.amount = this.amountRange
            } else {
                //非区间
                this.baoe.forEach(item => {
                    amountOptions.push(parseInt(item.split('万')[0]) * 1E6)
                })
                this.productLibraryInfo.amount = {
                    range: false,
                    options: amountOptions
                }
            }
            

            this.productLibraryInfo.basicInfo.alias = alias
            this.productLibraryInfo.basicInfo.description = description
            this.productLibraryInfo.basicInfo.tags = tags
            this.productLibraryInfo.validPeriodOptions = validPeriodOptions
            this.productLibraryInfo.requirement.conditionSet.conditions[0].params.min = this.conditionAgeMin
            this.productLibraryInfo.requirement.conditionSet.conditions[0].params.min.age = true
            this.productLibraryInfo.requirement.conditionSet.conditions[0].params.max = this.conditionAgeMax
            this.productLibraryInfo.requirement.conditionSet.conditions[0].params.max.age = true
            this.productLibraryInfo.basicInfo.waitingPeriod = parseInt(this.productLibraryInfo.basicInfo.waitingPeriod)
            this.productLibraryInfo.basicInfo.coolingOffPeriod = parseInt(this.productLibraryInfo.basicInfo.coolingOffPeriod)
            this.productLibraryInfo.basicInfo.coolingOffPeriod = parseInt(this.productLibraryInfo.basicInfo.coolingOffPeriod)
            this.productLibraryInfo.basicInfo.companyId = parseInt(this.productLibraryInfo.basicInfo.companyId)
            this.productLibraryInfo.payMethodOptions = payMethodOptions

            console.log(JSON.stringify(this.productLibraryInfo))

            request.library
                .post(
                    'save',
                    this.productLibraryInfo
                )
                .then(() => {
                    //console.log(r)
                    this.$message.success('提交成功')
                    this.dialogVisible = !this.dialogVisible
                    this.$router.push({
                        path:  '/product_library/list'
                    })
                });
        },
        addRows(type){
            if(type === 'payMethod' || type === 'payMethodAge') {
                this[type].push({
                    value: '',
                    payMonthly: false
                })
            } else {
                this[type].push({value: ''})
            }
        },
        removeRows(type, index){
            this[type].splice(index, 1)
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        },
    }
}
</script>
<style scoped>
.el-input{
    width: 400px;
}
.title{
    font-weight: 600;
}
.box-margin{
    margin: 20px 0 20px 30px;
}
.pay-method-box{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.pay-method-box >span{
    margin: 0 10px;
    font-size: 14px;
}
.label-text{
    margin: 0 0 0 50px;
    font-size: 12px !important;
    color: #606266;
}

</style>
